import {Tag, TagColor, TagSize} from '@benchling/nucleus-ui';
import React from 'react';

import {ExtensionTag, ExtensionType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {EXTENSION_TYPE_LABELS} from './extensionConstants';

interface ExtensionTagsProps {
  extensionType: ExtensionType;
  tags: ReadonlyArray<ExtensionTag>;
}

export default function ExtensionTags({extensionType, tags}: ExtensionTagsProps): JSX.Element {
  return (
    <>
      <Tag text={EXTENSION_TYPE_LABELS[extensionType]} size={TagSize.SMALL} color={TagColor.SECONDARY} />
      {tags.includes(ExtensionTag.FEATURED_PARTNER) && (
        <Tag text="Featured Partner" size={TagSize.SMALL} color={TagColor.LIME} />
      )}
    </>
  );
}
